import { render } from "./createList.vue?vue&type=template&id=bf76dc7a&scoped=true"
import script from "./createList.vue?vue&type=script&lang=js"
export * from "./createList.vue?vue&type=script&lang=js"

import "./createList.vue?vue&type=style&index=0&id=bf76dc7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf76dc7a"]])

export default __exports__